import React, { useState } from 'react';

interface PeriodSelectorProps {
  selected: string;
  onSelect: (period: string, startDate?: string, endDate?: string) => void;
}

const PERIODS = [
  { key: 'today', label: 'Today' },
  { key: 'yesterday', label: 'Yesterday' },
  { key: 'week', label: 'This Week' },
  { key: 'mtd', label: 'MTD' },
  { key: '30d', label: '30 Days' },
  { key: 'lastmonth', label: 'Last Month' },
  { key: 'ytd', label: 'YTD' },
  { key: 'custom', label: 'Custom' },
];

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({ selected, onSelect }) => {
  const [showCustom, setShowCustom] = useState(false);
  const [customStart, setCustomStart] = useState('');
  const [customEnd, setCustomEnd] = useState('');

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {PERIODS.map(p => (
        <button
          key={p.key}
          onClick={() => {
            if (p.key === 'custom') {
              setShowCustom(true);
            } else {
              setShowCustom(false);
              onSelect(p.key);
            }
          }}
          className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${
            selected === p.key
              ? 'bg-blue-600 text-white'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
        >
          {p.label}
        </button>
      ))}
      {showCustom && (
        <div className="flex items-center gap-2 ml-2">
          <input
            type="date"
            value={customStart}
            onChange={e => setCustomStart(e.target.value)}
            className="border border-gray-300 rounded px-2 py-1 text-sm"
          />
          <span className="text-gray-400">to</span>
          <input
            type="date"
            value={customEnd}
            onChange={e => setCustomEnd(e.target.value)}
            className="border border-gray-300 rounded px-2 py-1 text-sm"
          />
          <button
            onClick={() => {
              if (customStart && customEnd) onSelect('custom', customStart, customEnd);
            }}
            className="px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700"
          >
            Apply
          </button>
        </div>
      )}
    </div>
  );
};
